<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'EDIT_PROFILE' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="onCancel()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <form #editForm="ngForm" (ngSubmit)="onSubmit()" *ngIf="editedProfile">
    <ion-list>
      <ion-item>
        <ion-input label="{{ 'FIRST_NAME' | translate }}" labelPlacement="floating" type="text"
          [(ngModel)]="editedProfile.name.firstname" name="firstname" required
          (ionChange)="onInputChange()"></ion-input>
      </ion-item>

      <ion-item>
        <ion-input label="{{ 'LAST_NAME' | translate }}" labelPlacement="floating" type="text"
          [(ngModel)]="editedProfile.name.lastname" name="lastname" required (ionChange)="onInputChange()"></ion-input>
      </ion-item>

      <ion-item>
        <ion-input label="{{ 'EMAIL' | translate }}" labelPlacement="floating" type="email"
          [value]="editedProfile.email" name="email" readonly="true" disabled="true"></ion-input>
      </ion-item>

      <ion-item>
        <ion-select label="{{ 'AFFILIATION' | translate }}" labelPlacement="floating"
          [(ngModel)]="editedProfile.affiliation" name="affiliation" required (ionChange)="onInputChange()">
          <ion-select-option *ngIf="editedProfile?.affiliation && !isInAffiliations(editedProfile.affiliation)"
            [value]="editedProfile.affiliation">{{ getAffiliationName(editedProfile.affiliation) | translate }}</ion-select-option>
          <ion-select-option *ngFor="let aff of availableAffiliations" [value]="aff.value">{{ aff.name | translate
            }}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item *ngIf="isOtherAffiliation()">
        <ion-input label="{{ 'OTHER_AFFILIATION' | translate }}" labelPlacement="floating" type="text"
          [(ngModel)]="editedProfile.affiliation" name="customAffiliation" required
          (ionChange)="onInputChange()"></ion-input>
      </ion-item>

      <ion-item button="true" (click)="openCountryModal()">
        <ion-label>{{ 'COUNTRY' | translate }}<span *ngIf="expertStatus"></span></ion-label>
        <ion-note slot="end">{{ selectedCountry?.name || '' }}</ion-note>
      </ion-item>
      <ion-note color="danger" *ngIf="expertStatus && expertFieldErrors['country']">{{ 'EXPERT_FIELD_COUNTRY_REQUIRED' |
        translate }}</ion-note>

      <ion-item button="true" (click)="openLanguageModal()">
        <ion-label>{{ 'LANGUAGES' | translate }}<span *ngIf="expertStatus"></span></ion-label>
        <ion-note slot="end">{{ getSelectedItemsString(selectedLanguages) }}</ion-note>
      </ion-item>
      <ion-note color="danger" *ngIf="expertStatus && expertFieldErrors['languages']">{{
        'EXPERT_FIELD_LANGUAGES_REQUIRED' | translate }}</ion-note>

      <ion-item>
        <ion-select label="{{ 'FIELD_OF_STUDY' | translate }}" labelPlacement="floating"
          [(ngModel)]="editedProfile.fieldOfStudy" name="fieldOfStudy" (ionChange)="onInputChange()">
          <ion-select-option *ngIf="editedProfile?.fieldOfStudy && !isInFieldsOfScience(editedProfile.fieldOfStudy)"
            [value]="editedProfile.fieldOfStudy">{{ editedProfile.fieldOfStudy }}</ion-select-option>
          <ion-select-option *ngFor="let field of availableFieldsOfScience" [value]="field.value">{{ field.name |
            translate }}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-note color="danger" *ngIf="expertStatus && expertFieldErrors['fieldOfStudy']">{{
        'EXPERT_FIELD_FIELD_OF_STUDY_REQUIRED' | translate }}</ion-note>

      <ion-item *ngIf="isOtherFieldOfStudy()">
        <ion-input label="{{ 'OTHER_FIELD_OF_STUDY' | translate }}" labelPlacement="floating" type="text"
          [(ngModel)]="editedProfile.fieldOfStudy" name="customFieldOfStudy" (ionChange)="onInputChange()"></ion-input>
      </ion-item>

      <ion-item button="true" (click)="openExpertiseAreasModal()">
        <ion-label>{{ 'EXPERTISE_AREAS' | translate }}<span *ngIf="expertStatus"></span></ion-label>
        <ion-note slot="end">{{ getSelectedItemsString(selectedExpertiseAreas) }}</ion-note>
      </ion-item>
      <ion-note color="danger" *ngIf="expertStatus && expertFieldErrors['expertiseAreas']">{{
        'EXPERT_FIELD_EXPERTISE_AREAS_REQUIRED' | translate }}</ion-note>

      <ion-item>
        <ion-select label="{{ 'FOCUS_AREAS' | translate }}" labelPlacement="floating"
          [(ngModel)]="editedProfile.focusAreas" name="focusAreas" multiple="true" required
          (ionChange)="onInputChange()">
          <ion-select-option *ngFor="let area of availableFocusAreas" [value]="area.value">
            {{ area.name | translate }}
          </ion-select-option>
        </ion-select>
      </ion-item>
      <ion-note color="danger" *ngIf="expertStatus && expertFieldErrors['focusAreas']">
        {{ 'EXPERT_FIELD_FOCUS_AREAS_REQUIRED' | translate }}
      </ion-note>

      <ion-note *ngIf="expertStatus" class="expert-note">
        {{ 'EXPERT_PROFESSIONAL_REFERENCE_INFO' | translate }}
      </ion-note>

      <ion-item>
        <ion-input label="{{ 'INSTITUTIONAL_WEBPAGE' | translate }}" labelPlacement="floating" type="url"
          [(ngModel)]="editedProfile.institutionalWebpage" name="institutionalWebpage"
          (ionChange)="onInputChange()"></ion-input>
      </ion-item>
      <ion-note color="danger" *ngIf="websiteErrors['institutionalWebpage']">{{ 'WEBSITE_INVALID_FORMAT' | translate
        }}</ion-note>

      <ion-item>
        <ion-input label="{{ 'PERSONAL_WEBSITE' | translate }}" labelPlacement="floating" type="url"
          [(ngModel)]="editedProfile.personalWebsite" name="personalWebsite" (ionChange)="onInputChange()"></ion-input>
      </ion-item>
      <ion-note color="danger" *ngIf="websiteErrors['personalWebsite']">{{ 'WEBSITE_INVALID_FORMAT' | translate
        }}</ion-note>

      <ion-item>
        <ion-input label="{{ 'RESEARCH_GROUP_WEBSITE' | translate }}" labelPlacement="floating" type="url"
          [(ngModel)]="editedProfile.researchGroupWebsite" name="researchGroupWebsite"
          (ionChange)="onInputChange()"></ion-input>
      </ion-item>
      <ion-note color="danger" *ngIf="websiteErrors['researchGroupWebsite']">{{ 'WEBSITE_INVALID_FORMAT' | translate
        }}</ion-note>
      <ion-note color="danger" *ngIf="expertStatus && expertFieldErrors['professionalReference']">
        {{ 'EXPERT_FIELD_PROFESSIONAL_REFERENCE_REQUIRED' | translate }}
      </ion-note>

      <ion-item lines="none">
        <ion-checkbox slot="start" [(ngModel)]="expertStatus" name="expertStatus" (ionChange)="onExpertStatusChange()"
          [disabled]="editedProfile.status === 'declined'"></ion-checkbox>
        <ion-label>{{ 'APPLY_AS_EXPERT' | translate }}</ion-label>
      </ion-item>
      <ion-note color="danger" *ngIf="editedProfile?.status === 'declined'">{{ 'EXPERT_REGISTRATION_DECLINED' |
        translate }}</ion-note>

      <ng-container *ngIf="expertStatus">
        <ion-note class="expert-note expert-visibility-note">
          {{ 'EXPERT_DATABASE_VISIBILITY_NOTICE' | translate }}
        </ion-note>

        <ion-item lines="none" class="consent-item">
          <ion-checkbox slot="start" [(ngModel)]="editedProfile.mediaContactConsent" name="mediaContactConsent"
            (ionChange)="onInputChange()"></ion-checkbox>
          <ion-label class="consent-label">{{ 'MEDIA_CONTACT_CONSENT' | translate }}</ion-label>
        </ion-item>
      </ng-container>
    </ion-list>
  </form>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="onCancel()">{{ 'CANCEL' | translate }}</ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="onSubmit()" [disabled]="!validateForm()">{{ 'SAVE_CHANGES' | translate }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
